import { Box, Typography } from "@mui/material";

export default function NotFound() {
	return (
		<Box>
			<Typography>How did you end up here?! This page doesn't exist...</Typography>
		</Box>
	);
};
